import { useCallback } from "react";
import { useT } from "./I18nProvider";

/**
 * 라우트 라벨 해석 (ADR 0025 · Issue #13)
 * --------------------------------------------------------------------------
 * nav·Command Palette가 **같은 규칙**으로 라벨을 고릅니다. 두 곳에 복붙하면
 * 한쪽만 옮겨져 같은 화면이 서로 다른 이름으로 보입니다.
 *
 * 확장 기여(ADR 0024)에는 메시지 ID가 없습니다 — 매니페스트가 준 이름을 그대로
 * 씁니다. 확장 이름을 코어 카탈로그에 적으면 확장을 더할 때마다 이 저장소를
 * 고쳐야 합니다.
 */
export interface LabeledRoute {
  label: string;
  labelId?: string;
}

export function useRouteLabel(): (route: LabeledRoute) => string {
  const { t } = useT("nav");
  return useCallback((route: LabeledRoute) => (route.labelId ? t(route.labelId) : route.label), [t]);
}
